import React from 'react';
import Header from '@/lighting-app/components/Header';
import InspectWizardClient from './components/InspectWizardClient';

export default function InspectExistingLightingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-20">
        <InspectWizardClient />
      </main>
    </div>
  );
}